import React, { ReactElement, SyntheticEvent } from 'react';
import { styled } from '@linaria/react';
import { TitleBarVariant } from '@daedalus/atlas/helpers/TitleBar';
import { BrandBottomSheet } from '../../../../dealFreeze/components/BrandBottomSheet';
interface Props {
  isOpen: boolean;
  IconComponent?: ReactElement | null;
  TitleComponent?: ReactElement | null;
  MainContentComponent?: ReactElement | null;
  BottomContentComponent?: ReactElement | null;
  onClose?: (e?: SyntheticEvent, element?: string) => void;
  /** Whether the bottom sheet should match the height of the content or the full height of the viewport */
  hasFixedHeight?: boolean;
  ignoreSnapPoints?: boolean;
  headerVariant?: TitleBarVariant;
}
const BottomSheetContent = /*#__PURE__*/styled('div')({
  name: "BottomSheetContent",
  class: "butteeq",
  propsAsIs: false
});
export const BottomSheet = ({
  isOpen,
  IconComponent,
  TitleComponent,
  MainContentComponent,
  BottomContentComponent,
  hasFixedHeight = false,
  ignoreSnapPoints,
  headerVariant = 'default',
  onClose
}: Props) => <BrandBottomSheet isOpen={isOpen} onClose={onClose} iconComponent={IconComponent} hasFixedHeight={hasFixedHeight} ignoreSnapPoints={ignoreSnapPoints} headerVariant={headerVariant}>
    {Boolean(TitleComponent) && TitleComponent}
    <BottomSheetContent>
      {Boolean(MainContentComponent) && MainContentComponent}
      {Boolean(BottomContentComponent) && BottomContentComponent}
    </BottomSheetContent>
  </BrandBottomSheet>;

require("./BottomSheet.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./BottomSheet.tsx");